import IconButtonM from "@common/components/button/IconButtonM"
import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React, { useState } from "react"
import { useForm } from "react-hook-form"
import { Dimensions, View } from "react-native"
import SelectChapterScreen from "./SelectChapterScreen"

/**
 * Modal wrapper around SelectChapterScreen
 * Used to select a chapter in contexts outside of the main form flow
 */
const ChapterSelectionModal = ({
    visible,
    onDismiss,
    onSelectChapter,
    studentId = null,
    initialSchoolSubjectId = null,
    initialClass = null,
    hasStudyProgram = false,
    title = "Choisir un chapitre",
}) => {
    // Create a minimal form control for SelectChapterScreen
    const { control, watch } = useForm({
        defaultValues: {
            chapter: { studentId },
            subject: initialSchoolSubjectId?.toString() || "",
            class: initialClass || "",
            student_ids: studentId ? [studentId] : [],
        },
    })

    const formValues = watch()

    // Calculate modal width: min(95% of window, 700px)
    const windowWidth = Dimensions.get("window").width
    const modalWidth = Math.min(windowWidth * 0.95, 700)
    const [containerWidth, setContainerWidth] = useState(modalWidth)

    const handleGoToNextStep = () => {
        const selectedChapter = formValues.chapter
        if (selectedChapter && selectedChapter.id) {
            onSelectChapter(selectedChapter)
        }
        onDismiss()
    }

    return (
        <ModalM
            visible={visible}
            onDismiss={onDismiss}
            style={{
                height: "85%",
                maxWidth: 700,
                width: "95%",
            }}
        >
            <View style={{ height: "100%", width: "100%" }}>
                {/* Header */}
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 15,
                        borderBottomWidth: 1,
                        borderBottomColor: theme.colors.lightMore,
                    }}
                >
                    <IconButtonM
                        icon={"times"}
                        iconColor={theme.colors.primary}
                        containerColor={theme.colors.white}
                        onPress={onDismiss}
                        size={24}
                    />
                    <TextM
                        fontSize={18}
                        fontWeight="Bold"
                        color={theme.colors.primary}
                        style={{ marginLeft: 10 }}
                    >
                        {title}
                    </TextM>
                </View>

                {/* SelectChapterScreen */}
                <View
                    style={{ flex: 1 }}
                    onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}
                >
                    <SelectChapterScreen
                        control={control}
                        goToNextStep={handleGoToNextStep}
                        formValues={formValues}
                        hasStudyProgram={hasStudyProgram}
                        noNavigation={true}
                        containerWidth={containerWidth}
                        onChapterSelect={(chapter) => {
                            onSelectChapter(chapter)
                            onDismiss()
                        }}
                    />
                </View>
            </View>
        </ModalM>
    )
}

export default ChapterSelectionModal
